"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _ipath = require("ipath");

var _common = require("./common");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var createAction = function createAction(t, action) {
  var type = (0, _common.toSet)(t);
  return [type, function (payload, params) {
    return {
      type: type,
      path: action.path || t,
      payload: (0, _ramda.isNil)(payload) ? null : payload,
      params: params
    };
  }];
};

var createHttpActions = function createHttpActions(t, action) {
  var types = (0, _common.toHttpMethods)(t, action);

  var fn = function fn(type) {
    return function (body, params) {
      if (!params && !(0, _common.hasBody)(type[0])) {
        params = body;
        body = null;
      }

      return {
        type: type[1],
        url: (0, _common.replace)(action.url, params),
        path: action.path || t,
        params: params,
        body: body && (action.body ? action.body(body) : body)
      };
    };
  };

  return types.map(function (type) {
    return [type[1], fn(type)];
  });
};

var _default = function _default(l) {
  l = (0, _common.attachDefault)(l);
  return (0, _ramda.fromPairs)((0, _ramda.reduce)(function (p, c) {
    var a1 = createAction(c, l[c]);
    return l[c].url ? _toConsumableArray(p).concat(_toConsumableArray(createHttpActions(c, l[c])), [a1]) : _toConsumableArray(p).concat([a1]);
  }, [], Object.keys(l)));
};

exports.default = _default;